import { ReactNode } from "react";
import { ReconciliationModal } from "features/reconciliation/components/ReconciliationModal";
import { StatisticsModal } from "features/statistics/components/StatisticsModal/StatisticsModal";
import { ImportModal } from "features/import/components/ImportModal";

export interface UserModalRendererProps {
  modalName: string;
  openModal: boolean;
  handleCloseModal: () => void;
}

export const UserModalRenderer = ({
  openModal,
  handleCloseModal,
  modalName,
}: UserModalRendererProps) => {
  const ModalNameMap: Record<string, ReactNode> = {
    ImportMaster: (
      <ImportModal
        title="Import Masterfile"
        open={openModal}
        onClose={handleCloseModal}
        type="MASTER"
      />
    ),
    ImportPortfolio: (
      <ImportModal
        title="Import Portfolio"
        open={openModal}
        onClose={handleCloseModal}
        type="PORTFOLIO"
      />
    ),
    ReconciliationExt: (
      <ReconciliationModal
        title="Reconciliation Ext."
        open={openModal}
        onClose={handleCloseModal}
        type="EXTERNAL"
      />
    ),
    ReconciliationInt: (
      <ReconciliationModal
        title="Reconciliation Int."
        open={openModal}
        onClose={handleCloseModal}
        type="INTERNAL"
      />
    ),
    StatisticsExt: (
      <StatisticsModal
        title="Statistics Ext."
        open={openModal}
        onClose={handleCloseModal}
        type="EXTERNAL"
      />
    ),
    StatisticsInt: (
      <StatisticsModal
        title="Statistics Int."
        open={openModal}
        onClose={handleCloseModal}
        type="INTERNAL"
      />
    ),
  };

  const modal = ModalNameMap[modalName];

  if (!modal) {
    return null;
  }

  return <>{modal}</>;
};
